import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { Link, generatePath } from 'react-router-dom'
import { Panel, Button, ButtonGroup } from 'rsuite'
import LegacyListIcon from '@rsuite/icons/legacy/List'
import ProductGrid from '@components/catalog/product/ProductGrid'

import {
  ROUTE_CATALOG_PRODUCT_ADD,
  ROUTE_CATALOG_CATEGORIES,
  ROUTE_CATALOG_PRODUCT_REVIEWS
} from '@@partner:config/routes'

import CatalogTopMenu from '@components/catalog/CatalogTopMenu'
import CatalogStats from '@components/catalog/CatalogStats'

export default function CatalogPage () {
  const { brandSlug } = usePartner()

  return (
    <div className="CatalogPage">
      <h1 className="u-heading">Каталог товаров</h1>
      <CatalogTopMenu />

      <CatalogStats />
      {brandSlug && (
        <div>
          <ProductGrid brandSlug={brandSlug} />
        </div>
      )}
    </div>
  )
}
